import { lazy } from 'react';
const MouldTunnel = lazy(() => import('./MouldTunnel'));

const MouldTunnelRoutes = [
  {
    path: '/mouldtunnel',
    component: MouldTunnel
  }
];

export default MouldTunnelRoutes;
